import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const adminApi = axios.create({ baseURL: API_BASE });

// Attach token automatically
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('dyssc_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Surface 401 → login redirect (handled in component). Also normalise `detail`
// to a string: FastAPI 422s send a list of objects, which would crash toasts.
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('dyssc_admin_token');
      const p = window.location.pathname;
      if (p.startsWith('/admin') && !p.startsWith('/admin/login') && !/\/admin\/(login|auth)/.test(err.config?.url || '')) {
        window.location.assign(`/admin/login?next=${encodeURIComponent(p)}`);
      }
    }
    const d = err.response?.data;
    if (d && typeof d === 'object' && d.detail !== undefined && typeof d.detail !== 'string') {
      const det = d.detail;
      d.detail = Array.isArray(det)
        ? det.map((x) => (x && typeof x === 'object' ? `${(x.loc || []).slice(1).join('.')}: ${x.msg || JSON.stringify(x)}` : String(x))).join('; ')
        : JSON.stringify(det);
    }
    return Promise.reject(err);
  }
);
